import { getUserProfile, setUserProfile } from '../api'

const createProtectUserProfile = (userProfile) => {
  if (!userProfile) {
    return { error: true }
  }

  const cleanedProfile = { ...userProfile }
  Object.keys(cleanedProfile).forEach((key) => {
    cleanedProfile[key] = cleanedProfile[key] ?? ''
  })
  return cleanedProfile
}

export const getReklaimProtectUserProfile = async (userAlias) => {
  let userProfile
  try {
    userProfile = await getUserProfile(userAlias)
  } catch (error) {
    userProfile = null
  }
  return createProtectUserProfile(userProfile?.userProfile)
}

export const setReklaimProtectUserProfile = async (userAlias, data) => setUserProfile(userAlias, data)
